import { forwardRef, useImperativeHandle, useMemo, useRef } from "react";
import { ListWrapper } from "./DeviceListTab.styles";
import { defaultColumns } from "../../../../utils/columnConfigs/deviceListConfig";
import { useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { routes } from "../../../../utils/routeHelper";
import { DeviceTabTypeEnum } from "../../../../types/DeviceTabTypeEnum";
import { CoreDeviceListRef } from "@gf-core/widgets/types/CoreDeviceListRef";
import CoreDeviceList from "@gf-core/widgets/widgets/CoreDeviceList";
import { useStore } from "../../../../store/store";

interface Props {}

const DeviceListTab = forwardRef<CoreDeviceListRef, Props>((_, ref) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const showAppStoreFeature = useStore.useShowAppStoreFeature();
  const { accountId, installationId, deviceId, tabIndex } = useParams();
  const deviceListRef = useRef<CoreDeviceListRef>(null);

  useImperativeHandle(ref, () => {
    return {
      ...(deviceListRef.current as CoreDeviceListRef),
    };
  }, [deviceListRef.current]);

  const column = useMemo(
    () =>
      defaultColumns(
        false,
        installationId ?? "",
        () => deviceListRef.current?.refetch(),
        (productId: string) => {
          navigate(routes.product.set(productId));
        },
        false,
        false,
        deviceListRef.current?.data?.model.some((d) => !!d.capabilities) ??
          false,
        t,
        showAppStoreFeature ? accountId : undefined,
      ),
    [installationId, deviceListRef.current, t, showAppStoreFeature, accountId],
  );

  return (
    <ListWrapper>
      <CoreDeviceList
        columns={column}
        installationId={installationId ?? ""}
        deviceId={deviceId ?? ""}
        isExpanded
        cellStyles={{ height: 48 }}
        ref={deviceListRef}
        pageSize={100}
        onRowClick={(row) => {
          navigate(
            routes.device.set(
              accountId ?? "",
              installationId ?? "",
              row.original.deviceTwinId,
              tabIndex as DeviceTabTypeEnum,
            ),
          );
        }}
      />
    </ListWrapper>
  );
});

export default DeviceListTab;
